var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnedrivePrdct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 63,
    viewBox: "0 0 100 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2919_159",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 63
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4681 62.5C10.9546 62.5 0 51.7736 0 38.5417C0 25.6004 10.4788 15.0558 23.5816 14.5988C28.9855 5.84895 38.795 0 50 0C64.4713 0 76.6152 9.75571 79.9464 22.9172C91.0364 23.0008 100 31.8298 100 42.7083C100 53.2895 90.625 62.5 80.8511 62.4731L24.4681 62.5Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2919_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4678 62.5004C16.8055 62.5004 9.96593 59.0519 5.47949 53.6534L56.3826 32.2922L95.9637 54.5772C92.4753 59.1286 87.2068 62.5004 81.2498 62.4735C72.2654 62.5004 37.6951 62.5004 24.4678 62.5004Z",
    fill: "url(#paint0_linear_2919_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9314 22.8584L56.3828 32.2912L95.9641 54.5763C98.4983 51.2696 99.9999 47.1606 99.9999 42.7081C99.9999 31.8296 91.0363 23.0007 79.9463 22.917C79.9414 22.8974 79.9364 22.8779 79.9314 22.8584Z",
    fill: "url(#paint1_linear_2919_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0771 14.6963L56.3829 32.2917L79.9315 22.8588C76.5792 9.72689 64.4498 0 49.9999 0C38.7949 0 28.9854 5.84895 23.5816 14.5988C23.076 14.6165 22.5744 14.6491 22.0771 14.6963Z",
    fill: "url(#paint2_linear_2919_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47969 53.6531L56.383 32.2919L22.0772 14.6965C9.68583 15.8733 0 26.0999 0 38.5419C0 44.2711 2.05374 49.5306 5.47969 53.6531Z",
    fill: "url(#paint3_linear_2919_159)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2919_159",
    x1: 13.8295,
    y1: 58.3339,
    x2: 85.0952,
    y2: 53.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2086B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46D3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2919_159",
    x1: 74.4679,
    y1: 42.7079,
    x2: 94.4073,
    y2: 28.7749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1694DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62C3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2919_159",
    x1: 26.5956,
    y1: 4.16667,
    x2: 72.918,
    y2: 31.0462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2919_159",
    x1: -1.06384,
    y1: 43.7502,
    x2: 45.5107,
    y2: 26.4537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16589B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1464B7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedrivePrdct);
export default __webpack_public_path__ + "static/media/onedrive-prdct.4d39426409fbcd803affb0a9e19e8c2c.svg";
export { ForwardRef as ReactComponent };